<template>
    <v-row style="text-align:center;">
        <v-col v-if="!timeToSignOver">
            <qrcode-vue v-if="qrUrl" :value="qrUrl" level="H" :size="160"></qrcode-vue>
        </v-col>
        <v-col v-else>
            <div class="ultraLightGrey d-flex justify-center align-center text-center" style="width: 160px; height: 160px">
                <span></span>
            </div>
        </v-col>

        <v-col class="d-flex flex-column">
            <span class="mb-4">{{ $t('egovQr.useQrScanner') }}</span>
            <div v-if="signedData.status === 'SIGN'" class="d-flex align-center green--text">
                <v-icon size="24" class="green--text">mdi-check</v-icon>
                <span>Документ подписан!</span>
            </div>
            <div v-else-if="!timeToSignOver" class="full-height">
                <div v-if="!signedData || signedData.status === 'DONT_SIGN'">
                    <div class="d-flex align-center">
                        <div>
                            <v-progress-circular
                                :rotate="-90"
                                :size="24"
                                :width="4"
                                color="green"
                                :value="percentForCircular"
                                class="mr-2"
                            ></v-progress-circular>
                        </div>
                        <div>{{ $t('egovQr.qrCodeExpiresIn') + ': ' + timeRemaining.minutes + ':' + timeRemaining.seconds }}</div>
                    </div>
                </div>

                <div v-else class="d-flex full-height justify-space-between flex-column">
                    <div class="d-flex align-center red--text">
                        <v-icon size="24" class="red--text">mdi-close</v-icon>
                        <span>Документ не подписан!</span>
                    </div>

                    <v-hover v-slot="{ hover }">
                        <div class="d-flex align-center mb-2" @click="renewQrCode">
                            <v-icon class="mr-1" color="gray">mdi-autorenew</v-icon>
                            <span class="cursor: pointer" :class="{ 'text-decoration-underline': hover }" color="gray">
                                {{ $t('egovQr.updateWaitingTime') }}
                            </span>
                        </div>
                    </v-hover>
                </div>
            </div>
            <div v-else>
                <v-hover v-slot="{ hover }">
                    <div class="d-flex align-center mb-2" @click="renewQrCode">
                        <v-icon class="mr-1" color="gray">mdi-autorenew</v-icon>
                        <span class="cursor: pointer" :class="{ 'text-decoration-underline': hover }" color="gray">
                            {{ $t('egovQr.updateWaitingTime') }}
                        </span>
                    </div>
                </v-hover>
                <div class="d-flex align-center">
                    <div>
                        <v-progress-circular :rotate="-90" :size="24" :width="4" color="green" :value="percentForCircular" class="mr-2"></v-progress-circular>
                    </div>
                    <div>{{ $t('egovQr.activeQrCodeExpired') }}</div>
                </div>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import QrcodeVue from 'qrcode.vue';
import SignService from '@/services/apiRequests/sign.service';
import { sanitizeBase64Pdf } from '@/utils/base64ToFile';

export default {
    components: {
        QrcodeVue
    },
    name: 'QRCodeSign',
    props: ['document', 'id', 'file_name'],
    data: () => ({
        sign_data: null,
        qrUrl: '',
        expireDate: null,
        timeToSignOver: false,
        signedData: {
            status: ''
        },
        currentGuid: null,
        isConsumed: false,
        isChecking: false,
        timeRemaining: { minutes: 0, seconds: 0 },
        percentForCircular: null,
        signedInterval: null,
        updateTimerInterval: null,

        ttlSeconds: 0
    }),
    computed: {
        ...mapState('sign', ['stylus_response', 'sign_response', 'qr_response', 'qr_check_response'])
    },
    async mounted() {
        //await this.getQRLink(this.document);
    },
    watch: {
        document: {
            immediate: true,
            handler(val) {
                if (typeof val === 'string' && val.trim().length > 0) {
                    this.getQRLink();
                }
            }
        }
    },
    methods: {
        ...mapActions('sign', ['postSign', 'requestToSign', 'checkSign']),
        async save() {
            await this.postSign({ guid: this.guid, sign_data: this.sign_data, is_engineer: this.is_engineer, is_qr: true });
        },
        stopTimers() {
            if (this.updateTimerInterval) {
                clearInterval(this.updateTimerInterval);
                this.updateTimerInterval = null;
            }
            if (this.signedInterval) {
                clearInterval(this.signedInterval);
                this.signedInterval = null;
            }
        },
        resetState() {
            this.qrUrl = '';
            this.expireDate = null;
            this.timeToSignOver = false;
            this.signedData = { status: '' };
            this.timeRemaining = { minutes: 0, seconds: 0 };
            this.percentForCircular = null;
        },
        cleanup() {
            this.stopTimers();
            this.resetState();
        },
        renewQrCode() {
            this.getQRLink();
        },
        updateTimer(targetDate) {
            const currentDate = new Date();
            const differenceInSeconds = Math.max(0, Math.floor((targetDate - currentDate) / 1000));

            if (differenceInSeconds === 0) {
                this.timeToSignOver = true;
                clearInterval(this.updateTimerInterval);
                clearInterval(this.signedInterval);
                this.stopTimers();
            }

            const minutes = Math.floor(differenceInSeconds / 60);
            const seconds = differenceInSeconds % 60;

            this.timeRemaining = {
                minutes,
                seconds: seconds < 10 ? `0${seconds}` : seconds
            };

            if (this.ttlSeconds > 0) {
                this.percentForCircular = Math.round(((this.ttlSeconds - differenceInSeconds) / this.ttlSeconds) * 100);
            }
        },
        beforeDestroy() {
            this.cleanup();
        },
        async checkIfSigned(guid) {
            if (!guid || guid !== this.currentGuid || this.isConsumed) return;
            this.isChecking = true;
            const signData = await SignService.checkSign(guid);
            if (signData.status === 'SIGN') {
                const base64EncodedPDF = signData.data.documentsToSign[0].document.file.data;

                this.isConsumed = true;
                this.currentGuid = null;

                this.$emit('getQRData', base64EncodedPDF);

                this.signedData.status = 'SIGN';
                this.stopTimers();
                this.timeToSignOver = true;
                this.qrUrl = '';
                this.expireDate = null;
                this.percentForCircular = null;

                this.isConsumed = true;
                this.currentGuid = null;
            } else {
                this.signedData.status = 'DONT_SIGN';
            }
        },
        async getQRLink() {
            this.stopTimers();
            this.isConsumed = false;
            this.currentGuid = null;
            this.isChecking = false;
            try {
                const cleanBase64 = sanitizeBase64Pdf(this.document);
                if (!cleanBase64) {
                    console.error('[QRCodeSign] Пустой base64 документа — QR не будет сформирован');
                    this.$toast?.error?.('Не удалось сформировать документ для подписания');
                    return;
                }

                const fileName = (this.file_name || 'Предписание') + '.pdf';
                const payload = {
                    title: 'Подписание документа',
                    organization: { nameKz: 'АЛТС', nameRu: 'АЛТС', nameEn: 'АЛТС' },
                    signMethod: 'CMS_WITH_DATA',
                    documentsToSign: [
                        {
                            id: this.id,
                            nameRu: fileName,
                            nameKz: fileName,
                            nameEn: fileName,
                            meta: [{ name: 'тип запроса', value: 'Согласие' }],
                            document: { file: { mime: 'application/pdf', data: cleanBase64 } }
                        }
                    ]
                };

                this.timeToSignOver = false;
                this.signedData.status = '';
                const response = await this.requestToSign(payload);

                const guidFromQr = this.qr_response?.guid;
                const guidFromResp = response?.guid;

                if (!guidFromQr) {
                    console.error('[QRCodeSign] Нет qr_response.guid, response:', response, 'qr_response:', this.qr_response);
                    this.$toast?.error?.('Не удалось получить GUID для QR');
                    return;
                }
                if (guidFromResp && guidFromResp !== guidFromQr) {
                    console.warn('[QRCodeSign] ВНИМАНИЕ: response.guid != qr_response.guid', { guidFromResp, guidFromQr });
                }

                this.currentGuid = guidFromQr;

                this.qrUrl = `${this.qr_response.prefix}:${process.env.VUE_APP_QR_URL}/mgovSign/${this.qr_response.guid}`;

                this.expireDate = new Date(this.qr_response.expireDate);
                const now = new Date();
                this.ttlSeconds = Math.max(1, Math.floor((this.expireDate - now) / 1000));

                this.updateTimerInterval && clearInterval(this.updateTimerInterval);
                this.signedInterval && clearInterval(this.signedInterval);

                this.updateTimerInterval = setInterval(() => this.updateTimer(this.expireDate), 1000);
                this.signedInterval = setInterval(() => {
                    if (this.currentGuid) this.checkIfSigned(this.currentGuid);
                }, 1000);
            } catch (e) {
                console.error('[QRCodeSign] Ошибка в getQRLink:', e);
                this.$toast?.error?.('Ошибка при формировании QR-кода');
                this.stopTimers();
                this.resetState();
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
